import { Dispatch, SetStateAction, useCallback } from "react";
import axiosInstance from "../../service/axiosInstance";
import { API_DOMAIN, POST } from "../constants";
import { IClient } from "../../interfaces";
import { CalcIneligibleState } from "../../reducer/calcIneligibleReducer";

const useCalculateIneligibles = () => {
  const triggerCalculateUpc = useCallback(async (
    state: CalcIneligibleState,
    paramsForCalculateUPC: {
      sessionUuid: string;
      selectedClient: IClient;
      selectedEndDate: string;
    },
    isCalculatingIneligibles: boolean,
    setIsCalculatingIneligibles: Dispatch<SetStateAction<boolean>>,
  ) => {
    if (!state.isParentClientLevel || Object.keys(paramsForCalculateUPC).length === 0) { return; }
    if (state.hasInitiatedSubscription && !isCalculatingIneligibles) {
      const nonNullableSelectedClient = paramsForCalculateUPC.selectedClient as NonNullable<IClient> & Required<IClient>;
      const formattedDate = paramsForCalculateUPC.selectedEndDate.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');
      calculateUpc(paramsForCalculateUPC.sessionUuid, nonNullableSelectedClient, formattedDate, setIsCalculatingIneligibles);
    }
    const titlesForFinishedCalculation = ['Calculation Finished', 'Calculation Failed'];
    titlesForFinishedCalculation.includes(state.title) && setIsCalculatingIneligibles(false);
  }, [])

  const calculateUpc = useCallback(async (sessionUuid: string, selectedClient: IClient, selectedEndDate: string, setIsCalculatingIneligibles: Dispatch<SetStateAction<boolean>>) => {
    const nonNullableSelectedClient = selectedClient as NonNullable<IClient> & Required<IClient>;
    const formattedDate = selectedEndDate.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3');
    await axiosInstance.request({
      url: `${API_DOMAIN}/ar/calculateIneligibles/ineligibleSettingsForUPC`,
      method: POST,
      params: {
        sessionUuid: sessionUuid,
        parentBorrowerId: nonNullableSelectedClient.recordId,
        endDate: formattedDate
      }
    });
    setIsCalculatingIneligibles(true);
  }, []);

  return {
    triggerCalculateUpc
  };
};

export default useCalculateIneligibles;
